import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  saveFileRequest: ['payload'], // payload: { data }
  saveFileSuccess: null,
  saveFileFailure: ['payload'], // payload: { errors }
  saveFileReset: null, // payload: { errors }

})

export const ExcelTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: null,
  errors: false,
})

/* ------------- Functions for reducer cases ------------- */

const saveFileRequest = (state) =>
  state.merge({fetching: true})

const saveFileSuccess = (state) =>
  state.merge({fetching: false, result: true})

const saveFileFailure = (state, {payload: {errors}}) =>
  state.merge({fetching: false, errors})

const saveFileReset = (state) =>
  state.merge({fetching: false, result: null, errors: false})


/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SAVE_FILE_REQUEST]: saveFileRequest,
  [Types.SAVE_FILE_SUCCESS]: saveFileSuccess,
  [Types.SAVE_FILE_FAILURE]: saveFileFailure,
  [Types.SAVE_FILE_RESET]: saveFileReset,

})
